<template>
  <div>    
    <div class="row">
      <div class="col"> 
        <h1>Order Payment - Failed</h1>

          <div class="text-center py-5" v-if="isLoading">
              <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" ></b-spinner>
          </div>
        

          <b-alert variant="danger" :show="hasError && !isLoading">{{errorMessage}}</b-alert>

           <b-alert variant="danger" :show="!hasError && !isLoading" class="my-5">Payment not received for order {{ orderNumber }}</b-alert>

           <p v-if="!isLoading">
             <a :href="paymentLink">Back to order payment</a>
           </p>

           

      </div>
    </div>
  </div>
</template>

<script>

import frontendRepo from '@/api/repos/frontendRepo'


export default {
  mounted() {
    this.updateOrder()
    this.paymentLink = "/order/"+this.$route.params.id+"/pay"
  },

   data() {
    return {
      hasError:false,
      errorMessage:"",
      isLoading:true,
      orderNumber:'',
      paymentLink:''
    };
  },

  methods: {
   async updateOrder(){
     this.isLoading=true
     try{
       let {data} = await frontendRepo.paidFailed(this.$route.params.uid)
       this.orderNumber =data.order
     }catch($e){
       this.hasError=true
      this.errorMessage = "Something went wrong."

     }finally{
       this.isLoading=false
       console.log(this.isLoading)
     }
   }
  },

 
};
</script>

<style>
</style>